import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import { StartChallenges } from "../../../../redux/screen/startChallenge";
import StartNewChallenge from '../Qna/StartNewChallenge';
import ReachedLimit from '../Qna/component/ReachedLimit';

const StartChallengeNew = ({ challengeID }) => {
  const dispatch = useDispatch()

  const challengeDetails = useSelector(state => state.StartChallenges)
  const { data: challengeData, loading: missionDetailLoading, status, message } = challengeDetails
const navigate = useNavigate()


  useEffect(() => {
    dispatch(StartChallenges({ challenge_id: challengeID }))
  }, [dispatch, challengeID])

  if (!missionDetailLoading && challengeID !== null) {
    if (status !== 201 && status !== 409 && status !==200 && message?.length > 4) {
      alert(message)
      navigate("/home-challenge")
      return
    }
  }
  return (
    <>
      <div>
        {status === 409 ? <ReachedLimit /> : <StartNewChallenge qnaData={challengeData} isLogo={false} chId={challengeID} />}
      </div>
    </>
  )
}

export default StartChallengeNew;
